import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { Article } from "lib/articles";
import dynamic from "next/dynamic";
import { sharedColors } from "ui/theme/colors";
import ArticleCard from "./ArticleCard";
import { trackArticleSidebarClick } from "reusable/ChargeGTM";

const StyledWrapper = styled.div`
width: 100%;
`
const StyledSideBarArticles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const StyledButton = styled(Button)`
  width: 216px;
  height: 32px;
//   padding: 8px 20px 8px 20px;
  border-radius: 24px;
  opacity: 0px;
  background-color: ${sharedColors.blue};
  gap: 12px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 45px;
    // width: 300px;
    border-radius: 40px;
  }
`
// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const ARTICLES_NUMBER_DISPLAY = 5;

type Props = {
  articles: Article[],
  pageName: string
}
function MoreArticlesListDesktop({ articles, pageName }: Props) {
  return (
    <StyledWrapper>
      <StyledSideBarArticles>
        {articles.slice(0,ARTICLES_NUMBER_DISPLAY - 1).map((article, index) => 
        {
          const onClickAddedLogic = () => {
            trackArticleSidebarClick(article.name, index + 1 , pageName)
          }
          return <ArticleCard article={article} position={index}  onClickAddedLogic={onClickAddedLogic}/>
        })}
      </StyledSideBarArticles>
    </StyledWrapper>
  );
}
export default MoreArticlesListDesktop;
